import { useEffect, useState } from 'react';
import { Flag } from 'lucide-react';
import { ReportContentDialog } from './ReportContentDialog';
import { safetyService, type AIReportCategory } from '../services/safetyService';

const categories: { value: AIReportCategory; label: string }[] = [
  { value: 'unsafe_or_offensive', label: 'Unsafe or offensive' },
  { value: 'harassment_or_hate', label: 'Harassment or hate' },
  { value: 'sexual_content', label: 'Sexual content' },
  { value: 'self_harm', label: 'Self-harm concern' },
  { value: 'misinformation', label: 'Misinformation' },
  { value: 'privacy_concern', label: 'Privacy concern' },
  { value: 'other', label: 'Other' },
];

export function ReportAIResponseButton({ receiptId }: { receiptId?: string }) {
  const [open, setOpen] = useState(false);
  const [notice, setNotice] = useState('');
  useEffect(() => { setNotice(''); }, [receiptId]);
  if (!receiptId) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="mt-2 ml-10 flex min-h-9 items-center gap-1.5 rounded-full border px-3 text-xs"
        style={{ borderColor: 'var(--app-border)', color: 'var(--app-text-muted)' }}
        aria-label="Report AI response"
      >
        <Flag className="h-3.5 w-3.5" /> Report response
      </button>
      {notice && <p role="status" className="mt-1 ml-10 text-xs" style={{ color: 'var(--app-text-muted)' }}>{notice}</p>}
      <ReportContentDialog
        open={open}
        onOpenChange={setOpen}
        title="Report AI response"
        categories={categories}
        onSubmit={async (category, details) => {
          const acknowledgement = await safetyService.reportAI(
            receiptId, category as AIReportCategory, details,
          );
          setNotice(acknowledgement.already_reported
            ? 'This response was already reported. Our safety team has it.'
            : 'Report submitted. Our safety team will review it.');
        }}
      />
    </>
  );
}
